import { MockConsole } from "./common.test.mocks";
import { defaultConfig, IRapportConfig } from "./config";
import I18nBase, { II18n, TranslateFuncType } from "./i18n-base";
import { ILocale, Locale, LocaleCode } from "./locale";
import { IPhraseConstructorArgs, IPhraseOptions, Phrase } from "./phrase";
import * as PhraseMocks from "./phrase.test.mocks";
import { IRapportWebPackage } from "./rapport-web-package";

export {
  ILocale,
  Locale,
  LocaleCode,
  MockConsole,
  IPhraseConstructorArgs,
  IPhraseOptions,
  Phrase,
  PhraseMocks,
  defaultConfig,
  IRapportConfig,
  IRapportWebPackage,
  TranslateFuncType,
  I18nBase,
  II18n
};
